import { BUSCAR_CIDADES } from '../../actions/types'

const initialState = undefined

export default function reducerBuscarEstados (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_CIDADES: {
      const cidades = action.payload.data;

      if (cidades) {
        return cidades
      }
      return []
    }

    default: {
      return state
    }
  }
}
